import { jsx } from "@emotion/react/jsx-runtime";
import { FormInputField } from "@wsui/form";
import kebabCase from "lodash/kebabCase";
import "react";
function FormModuleInputField(_ref) {
  let {
    field: {
      label,
      description,
      required,
      valueType,
      minTimeValue,
      maxTimeValue,
      minValue,
      maxValue,
      step
      // conditionalLogic,
      // conditonalField,
    },
    ...restProps
  } = _ref;
  const inputProps = {};
  switch (valueType) {
    case "range":
    case "number":
      inputProps.step = step;
      inputProps.min = minValue;
      inputProps.max = maxValue;
      break;
    case "date":
      inputProps.min = String(minValue).replace(/^(\d{4})(\d{2})(\d{2})$/, "$1-$2-$3");
      inputProps.max = String(maxValue).replace(/^(\d{4})(\d{2})(\d{2})$/, "$1-$2-$3");
      break;
    case "time":
      inputProps.min = minTimeValue;
      inputProps.max = maxTimeValue;
      break;
  }
  return /* @__PURE__ */jsx(FormInputField, {
    name: kebabCase(label),
    label,
    type: valueType,
    inputProps,
    required,
    description,
    ...restProps
  });
}
export { FormModuleInputField as default };